<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col xs="12" md="8">
          <h1>Merci !</h1>
          <p>Votre réservation a été enregistrée, vous recevrez un e-mail de confirmation à l'adresse que vous avez indiquée. Merci de vous munir d'une copie de cet e-mail lorsque vous viendrez récupérer votre matériel au magasin.</p>
          <p>A très bientôt !</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Finish",
  created() {
    this.$store.dispatch("cart/empty");
    this.$store.dispatch("cart/changeNumberOfDays", 6);

    // This will only save the date
    this.$store.dispatch("cart/saveDate", new Date().toISOString().substr(0, 10));
  }
}
</script>
